<template >
    <el-row class="alltext" :style="{height:all_height}">
      <el-row >
        <el-col :offset="1" :span="22">
          <router-link :to="{path:'test_assembly',query:{num:''}}">
          <el-button type="primary" icon="el-icon-document-add" class="btnadd">组卷</el-button>
          </router-link>
          <el-table
            ref="eval_table"
            :data="exam_list.list"
            tooltip-effect="dark"
            style="width: 100%"
            :key="bomkey"
            :height="tow_height"
            >
            <el-table-column
              prop="name"
              label="试卷名称"
             >
             <template slot="header" slot-scope="scope">
                <el-input v-model="input" size="mini" @keyup.enter.native="input_change()" placeholder="输入关键字搜索" />
              </template>
            </el-table-column>
            <el-table-column
              prop="a_id"
              label="创建人"
             >
             </el-table-column>
             <el-table-column
               label="状态"
              >
              <template slot-scope="scope">
                <span v-if="scope.row.status==0" >编辑中</span>
                <span v-if="scope.row.status==-1" style="color:red;">已禁用</span>
                <span v-if="scope.row.status==-2" style="color:red;">已删除</span>
                <span v-if="scope.row.status==1" style="color:rgb(103, 194, 58);">已完成</span>
              </template>
             </el-table-column>
             <el-table-column
               prop="c_time"
               label="创建时间"
              >
            </el-table-column>
            <el-table-column
                  fixed="right"
                  label="操作"
                  width="120">
                  <template slot-scope="scope" v-if="scope.row.status >=0">
                    <span >
                      <router-link v-if="scope.row.status==0" :to="{path:'test_assembly',query:{num:scope.row.num}}">
                      <!-- <i class="el-icon-edit" ></i> -->
                      <span>编辑试卷</span>
                       </router-link>
                       <span style="cursor: pointer;"
                        v-if="scope.row.status==1" @click=" operation('release', scope.row)">
                         发布任务
                       </span>

                    </span>
                    <el-dropdown >
                    <span class="el-dropdown-link">
                      <i class="el-icon-more-outline"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" >
                        <el-dropdown-item v-if="scope.row.status" @click.native="() => operation('see', scope.row)">预览</el-dropdown-item>
                        <el-dropdown-item  v-if="scope.row.status==0" @click.native="() => operation('release', scope.row)" >发布</el-dropdown-item>
                        <el-dropdown-item @click.native="() => operation('disable',scope.row)">禁用</el-dropdown-item>
                        <el-dropdown-item @click.native="() => operation('del',scope.row)">删除</el-dropdown-item>
                    </el-dropdown-menu>
                   </el-dropdown>
                  </template>
                </el-table-column>
          </el-table>
           <el-pagination
                class="fenye"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="exam_list.currentPage"
                :page-size="exam_list.pageSize"
                :page-sizes="[5, 10, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="exam_list.total">
              </el-pagination>
        </el-col>


      </el-row>
    </el-row>
</template>

<script>
  export default{
    data(){
      return{
        input:'',
        all_height:'',
        tow_height:'',
        bomkey:'',
        exam_list:{
          list:[],
          currentPage:1,//当前页数
          pageSize:10,//一页显示多少条
          total:100,//总条数
          keyword:'',
        }
      }
    },
    mounted() {
      this.all_height=window.innerHeight  + 'px'
      this.tow_height=window.innerHeight *0.85  + 'px'
      this.get_list()
    },
    methods:{
      get_list(){
        let _this=this
        var keyword=_this.input
        _this.axios.get("/v2/c_evaluate/exam_list",{params: {
          page:Number(_this.exam_list.currentPage),
          limit:Number(_this.exam_list.pageSize),
          keyword:keyword
        }}).then(function (res) {
          if(res.data.code=='1'){
            _this.exam_list=res.data.data
            // _this.exam_list.keyword=keyword
          }else{
            _this.$message.error(res.data.msg)
          }
        })
      },
      operation(type,item){
        if(type=='see'){
          this.$router.push({path:'/eva_test_paper',query:{num:item.num}})
        }else if(type=='release'){
          if(item.status==0){
            let data={
              num:item.num,
              status:'1'
            }
            this.post_type_info(data)
          }else{
            this.$router.push({path:'/release',query:{num:item.num}})
          }

        }else if(type=='disable'){
          let data={
            num:item.num,
            status:'-1'
          }
          this.post_type_info(data)
        }else if(type=='del'){
          let data={
            num:item.num,
            status:'-2'
          }
          this.post_type_info(data)
        }
      },
      post_type_info(data){
        let _this=this
        _this.axios.post('/v2/c_evaluate/change_exam_status',{data:data}
        ).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.get_list()
              _this.$message({
                message: '操作成功',
                type: 'success'
              });
            }else{
              _this.$message.error(res.data.msg);
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        })
      },
      input_change(){
        this.get_list()
      },
      handleSizeChange(val){
        let _this=this
        _this.exam_list.pageSize=val
        _this.get_list()
      },
      handleCurrentChange(val) {
        let _this=this
        _this.exam_list.currentPage=val
        _this.get_list()
      },
    },
  }
</script>

<style scoped>
  .fenye{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.625rem;
  }
  .alltext{
    background-color: white;
  }
  .right{
     border: 2px solid red;
     border-radius: 5px;
     width: 100%;
  }
  .exam{
    overflow-x: auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/evaluate/test_paper/list.vue